import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import WWCCForm2 from "../User2/WWCCForm2"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"

class WWCC2 extends React.Component {
  state = {
    wwcc_filename: this.props.user.wwcc_filename,
    wwcc_issuing_state: this.props.user.wwcc_issuing_state,
    wwcc_url: this.props.user.wwcc_url,
    wwcc_expiry: parseDate(this.props.user.wwcc_expiry),
    wwcc_number: this.props.user.wwcc_number,
    wwcc_status: this.props.user.wwcc_verification_status,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ wwcc_expiry: date })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = ["wwcc_issuing_state", "wwcc_number", "wwcc_expiry"]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (errors) {
      notify.hide();
      notify.show("You are missing one or more field(s)!")
      errors = true
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  getTabs = () => {
    const tabs = [
      {
        pathname: "/personalid",
        text: "Personal ID",
      },
      {
        pathname: "/visa",
        text: "Visa Details",
      },
      {
        pathname: "/policecheck",
        text: "Police Check (Opt.)",
      },
      {
        pathname: "/wwcc",
        text: "WWCC (Optional)",
        active: true,
      },
      {
        pathname: "/usiCheck",
        text: "USI Check (Opt.)",
      }
    ]

    if (this.props.user?.is_elt) {
      tabs.push({
        pathname: "/uploadPayLevel",
        text: "Pay Level Evidence",
      })
    }

    if (this.props.user?.is_childhood_teacher) {
      tabs.push({
        pathname: "/ececcheck",
        text: "First AID",
      });
    }

    return tabs
  }

  tabs = this.getTabs()

  
  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <WWCCForm2
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleDateChange={this.handleDateChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WWCC2)
